import InitPersonalAccount from '@pages/InitPersonalAccount';
import ErrorBoundary from '@settings/ErrorBoundary';
import { SnackbarProvider } from 'notistack';
import React from 'react';

function PointInitPersonalAccount() {
  return (
    <ErrorBoundary needJSX={false}>
      <SnackbarProvider maxSnack={10} preventDuplicate={true} autoHideDuration={3000}>
        <InitPersonalAccount />
      </SnackbarProvider>
    </ErrorBoundary>
  );
}

export default PointInitPersonalAccount;
